import React from 'react';
import PropTypes from 'prop-types';
import {
	Row,
	Col,
	Button
} from 'react-bootstrap';
import  {
	blue,
	orange,
	videoblue,
	warning,
  StatusDescription,
} from '../../../utils/constants';

const box = { 
	textAlign: 'center',
	maxWidth: '170px',
	maxHeight:'90px',
	padding: '4px',
	fontSize:'13px',
	fontWeight:'bold',
	marginRight: '10px',
};
const bar = {
	height:'5px',
	width:'160px', 
};

const Stats = (props) => {
	const { 
		setupNotCompleted,
		comingup,
		pendingReport,
		completedcurrent,
		pendingApproval,
		onSearchEvents,
	} = props;

const handleSetupNotCompleted = () => {
	onSearchEvents(StatusDescription.SetupNotCompleted);
}

const handlePendingApproval = () => {
	onSearchEvents(StatusDescription.PendingApproval);
}

const handleUpcomingEvents = () => {
	onSearchEvents(StatusDescription.UpcomingEvent);
}

const handlePendingPostEventReport = () => {
	onSearchEvents(StatusDescription.PendingPost);
}

const handleCompletedCurrentSeason= () => {
	onSearchEvents(StatusDescription.Completed);
}

  return (<Row>
    <Col sm={2}>
			<Button
				style={{ ...box }}
				onClick={handleSetupNotCompleted}
			>
				<p>
					Setup Not Complete
				</p>
				<span>
					{setupNotCompleted}
				</span>
				<div
					style={{
						...bar,
						backgroundColor:blue, 
					}}

				/>
			</Button>
    </Col>
    <Col sm={2}>
			<Button
				style={{ ...box }}
				onClick={handlePendingApproval}
			>
				<p>
					Pending Approval
				</p>
				<span>
					{pendingApproval}
				</span>
				<div
					style={{
						...bar,
						backgroundColor:orange
					}}
				/>
			</Button>
    </Col>
    <Col sm={2}>
			<Button
				style={{ ...box }}
				onClick={handleUpcomingEvents}
			>
				<p>
					Upcoming Events
				</p>
				<span>
					{comingup}
				</span>
				<div style={{ ...bar, backgroundColor:videoblue }} />
			</Button>
    </Col>
    <Col sm={2}>
			<Button
				style={{ ...box }}
				onClick={handlePendingPostEventReport}
			>
				<p>
					Pending Post Event Report
				</p>
				<span>
					{pendingReport}
				</span>
				<div
					style={{
						...bar,
						backgroundColor:warning
					}}
				/>
			</Button>
    </Col>
		<Col sm={2}>
			<Button
				style={{ ...box }}
				onClick={handleCompletedCurrentSeason}
			>
				<p>
					Completed Current Season
				</p>
				<span>
					{completedcurrent}
				</span>
				<div
					style={{
						...bar,
						backgroundColor:'#4FFF00'
					}}
				/>
			</Button>
    </Col>
  </Row>)
}
Stats.propTypes = {
	setupNotCompleted: PropTypes.number,
	comingup: PropTypes.number,
	pendingReport: PropTypes.number,
	completedcurrent: PropTypes.number, 
	pendingApproval:PropTypes.number, 
	onSearchEvents: PropTypes.func,
};
export default Stats;


// WEBPACK FOOTER //
// ./src/containers/event/components/stats.js